export const USER_FEATURE_FOR_PROMOTED_AT_YOUR_DISTRICT_PAGE = 'can_access_promoted_at_your_district_page';

export const USER_FEATURE_FOR_PROMOTED_AT_YOUR_SCHOOL_PAGE = 'can_access_promoted_at_your_school_page';

export const USER_FEATURE_FOR_CRUDING_CONTENT_PROMOTION_CONFIGURATION = 'can_create_and_modify_content_promotion_configurations';
